import React from 'react';
import { Filter } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';
import UserAutocompleteInput from '../../../../commonComponents/UserAutocompleteInput';

const DigitalProductReportsFilter = (props) => (
  <Filter {...props}>
    <UserAutocompleteInput label="User" source="user_id" reference="admin/users/autocomplete" alwaysOn />
    <CustomDateInput label="Choose start date" source="start_date" start alwaysOn />
    <CustomDateInput label="Choose end date" source="end_date" end alwaysOn />
  </Filter>
);

export default DigitalProductReportsFilter;
